import { API_URL } from '../utils/api';

class CustomerApis {
  constructor(storeId) {
    this.storeId = storeId;
  }

  // Get all customers for a store
  async getCustomers() {
    try {
      const url = `${API_URL}/customers/${this.storeId}`;
      console.log('CustomerApis: Making request to:', url);
      console.log('CustomerApis: Store ID:', this.storeId);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('CustomerApis: Response status:', response.status);
      console.log('CustomerApis: Response ok:', response.ok);

      if (response.ok) {
        const data = await response.json();
        console.log('CustomerApis: Response data:', data);
        return data.customers || [];
      } else {
        const error = await response.json();
        console.error('CustomerApis: Error response:', error);
        return [];
      }
    } catch (error) {
      console.error('CustomerApis: Network error:', error);
      return [];
    }
  }

  // Create a new customer
  async createCustomer(customerData) {
    try {
      const response = await fetch(`${API_URL}/customers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...customerData,
          store_id: this.storeId,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return data.customer;
      } else {
        const error = await response.json();
        console.error('Error creating customer:', error);
        throw new Error(error.message || 'Failed to create customer');
      }
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  }

  // Update a customer
  async updateCustomer(customerId, customerData) {
    try {
      const response = await fetch(`${API_URL}/customers/${customerId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(customerData),
      });

      if (response.ok) {
        const data = await response.json();
        return data.customer;
      } else {
        const error = await response.json();
        console.error('Error updating customer:', error);
        throw new Error(error.message || 'Failed to update customer');
      }
    } catch (error) {
      console.error('Error updating customer:', error);
      throw error;
    }
  }

  // Delete a customer
  async deleteCustomer(customerId) {
    try {
      const response = await fetch(`${API_URL}/customers/${customerId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        return true;
      } else {
        const error = await response.json();
        console.error('Error deleting customer:', error);
        throw new Error(error.message || 'Failed to delete customer');
      }
    } catch (error) {
      console.error('Error deleting customer:', error);
      throw error;
    }
  }

  // Get a specific customer
  async getCustomer(customerId) {
    try {
      const response = await fetch(`${API_URL}/customers/single/${customerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.customer;
      } else {
        const error = await response.json();
        console.error('Error fetching customer:', error);
        return null;
      }
    } catch (error) {
      console.error('Error fetching customer:', error);
      return null;
    }
  }
}

export default CustomerApis; 